export const INTERVENTION_GROUP_DRAWER_TRANSITION_DURATION_MS = 300;

export const INTERVENTION_GROUP_DRAWER_TRANSITION_DURATION_CSS_VAR =
  '--intervention-group-drawer-transition-duration';
